
import { List, Input, Avatar, Badge, Spin, Pagination } from "antd";
import { useState, useMemo, useEffect } from "react";
import { useDebounce } from "../../../../../core/hooks/useDebounce";
import api from "../../../../../core/axios/axiosInstance";
import { clearEmptyDraftChats } from "../../../../../core/data/redux/slices/WabaChatSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { showToast } from "../../../../../core/data/redux/slices/ToastSlice";


const ChatList = ({ data: localChats, activeId, onSelect, onNewChat, loading, chatPage, setChatPage, totalCount, chatLimit, setChatLimit }) => {
  const [search, setSearch] = useState("");
  const dispatch = useDispatch()
  const location = useLocation()
  const debouncedSearch = useDebounce(search, 300);
  const [apiContacts, setApiContacts] = useState([]);
  const [isLoadingContacts, setIsLoadingContacts] = useState(false);

  const isHistoryPage =
    location.pathname === "/whatsapp/history" ||
    location.pathname === "/agent/whatsapp/history" ||
    location.pathname === "/admin/whatsapp/history";

  const isAdminHistoryPage = location.pathname === "/admin/whatsapp/history";

  const fetchContactsAndLeads = async (searchQuery = "") => {
    if (!searchQuery.trim()) return setApiContacts([]);

    try {
      setIsLoadingContacts(true);

      if (isAdminHistoryPage) {
        // Superadmin: search company admins + agents
        const response = await api.post("/superAdmin/allCompanyAdmin", { search: searchQuery, limit: 20 });
        const list = response.data?.data || [];
        const transformed = list.map((item) => {
          const name = `${item.firstname || ""} ${item.lastname || ""}`.trim() || item.email;
          const phone = item.phonenumbers?.[0]
            ? `${item.phonenumbers[0].countryCode || ""}${item.phonenumbers[0].number}`
            : item.telephone || "";
          return {
            id: `${item._id}`,
            name,
            phone,
            category: item.role === "companyAdmin" ? "Company Admin" : "Agent",
            lastMessage: "",
            unread: 0,
            image: "",
            isWabaChat: false,
          };
        });
        setApiContacts(transformed);
      } else {
        // Company admin / agent: search contacts & leads
        const response = await api.get("/getAllContactsOrLeads/ForWhatsapp", { params: { search: searchQuery } });
        const transformed = response.data.data.map((item) => {
          const name = `${item.firstname || ""} ${item.lastname || ""}`.trim();
          const phone = item.phoneNumbers?.[0]
            ? `+${item.phoneNumbers[0].countryCode}${item.phoneNumbers[0].number}`
            : "";
          return {
            id: `${item.id}`,
            name,
            phone,
            category: item.category,
            lastMessage: "",
            unread: 0,
            image: "",
            isWabaChat: item.isWabaChat,
          };
        });
        setApiContacts(transformed);
      }
    } catch (error) {
      console.error(error.response?.data?.message || "Error fetching search results");
      setApiContacts([]);
    } finally {
      setIsLoadingContacts(false);
    }
  };

  useEffect(() => {
    fetchContactsAndLeads(debouncedSearch);
  }, [debouncedSearch]);

  const filteredLocalChats = useMemo(() => {
    const query = debouncedSearch?.trim()?.toLowerCase();
    if (!query) return localChats;


    // return localChats.filter(
    //   (item) =>
    //     item?.messages.at(-1)?.name?.toLowerCase().includes(query) ||
    //     (item?.phone && item?.phone?.toLowerCase().includes(query)) ||
    //     (item?.from && item?.from?.toLowerCase().includes(query))
    // );
    return localChats.filter(
      (item) =>
        item?.chatName?.toLowerCase().includes(query) ||
        item?.originalName?.toLowerCase().includes(query) ||
        item?.phone?.toLowerCase().includes(query) ||
        item?.from?.toLowerCase().includes(query)
    );
  }, [localChats, debouncedSearch]);

  return (
    <div className="chat-list d-flex justify-content-between">
      <div><div className="chat-list-header">
        <strong>WhatsApp</strong>
        {/* <span onClick={onNewChat}>➕</span> */}
      </div>

        <div style={{ padding: "0 10px 20px" }}>
          <Input
            placeholder="Search by name or number"
            style={{ height: 40 }}
            size="small"
            value={search}
            onChange={(e) => {
              const value = e.target.value;

              setSearch(value);
              if (value.trim() === " ") {
                dispatch(clearEmptyDraftChats());
              }
            }}
          />

        </div>


        {loading ? (
          <div style={{ textAlign: "center", padding: "10px 0", fontSize: 14, color: "#555" }}>
            <Spin size="small" /> Loading chats...
          </div>
        ) : (
        <List
          itemLayout="horizontal"
          dataSource={filteredLocalChats}
          renderItem={(item) => (
            <List.Item
              className={`chat-item ${item.id === activeId ? "active" : ""}`}
              onClick={() => {
                console.log(item, "hjgfhvjbknljhjgf");

                onSelect(item)
              }}
            >
              <List.Item.Meta
                avatar={
                  <Badge count={item.unread}>
                    <Avatar
                      className="chat-avatar"
                      size={42}
                      src={item.image ? item.image : undefined}
                    >
                      {(item?.chatName || item?.originalName || item?.from || "?").charAt(0)}
                      {/* {(item.messages?.at(-1)?.name || item.name || "?").charAt(0)} */}
                    </Avatar>
                  </Badge>
                }
                title={<div className="chat-title-row">
                  <span className="chat-name">
                    {item?.chatName || item.originalName || item?.from}
                    {item?.chatCompany && (
                      <span style={{ fontSize: 11, color: "#888", marginLeft: 4 }}>
                        ({item.chatCompany})
                      </span>
                    )}
                  </span>
                  <span className="chat-time">
                    {item?.lastMessageTime
                      ? item.isWabaChat
                        ? new Date(item.lastMessageTime).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                        : new Date(item.lastMessageTime).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : ""}
                  </span>
                </div>}
                description={
                  <span className="chat-last-message">
                    {typeof item.lastMessage === "string"
                      ? item.lastMessage
                      : item.lastMessage?.body || "No messages yet"}
                  </span>
                }
              />

            </List.Item>
          )}
        />
        )}
        {isHistoryPage && <>
          {isLoadingContacts && debouncedSearch.trim() && (
            <div style={{ textAlign: "center", padding: 10 }}>
              <Spin size="small" /> Loading contacts...
            </div>
          )}
          {!isLoadingContacts && apiContacts.length > 0 && (
            <>
              <div style={{ padding: "5px 10px", fontSize: 12, color: "#888" }}>
                {isAdminHistoryPage ? "Company Admins / Agents" : "From Contacts / Leads"}
              </div>
              <List
                itemLayout="horizontal"
                dataSource={apiContacts}
                renderItem={(item) => (

                  <List.Item
                    className={`chat-item ${item.id === activeId ? "active" : ""}`}
                    onClick={() => {
                      console.log(item.phone, "phone number of clicked item");
                      if (!item.phone) {
                        dispatch(
                          showToast({
                            message: "Selected Contact does not have a Phone Number",
                            variant: "danger"
                          })
                        );
                        return; // stop further execution if needed
                      }
                      onNewChat(item)
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        <Avatar
                          className="chat-avatar"
                          size={42}
                          src={item.image ? item.image : undefined}
                        >
                          {item.name ? item.name.charAt(0) : "?"}
                        </Avatar>

                      }
                      title={
                        <span className="chat-name">
                          {item.name}{" "}
                          {item.category && (
                            <span
                              style={{ fontSize: 11, color: "#888", marginLeft: 4 }}
                            >
                              ({item.category})
                            </span>
                          )}
                        </span>
                      }
                      description={<span className="chat-last-message">{item.phone || ""}</span>}
                    />
                  </List.Item>
                )}
              />
            </>
          )}
        </>}
      </div>

      <div style={{ padding: "10px 16px", display: "flex", justifyContent: "center" }}>
        <Pagination
          current={chatPage}
          total={totalCount}
          pageSize={chatLimit}
          onChange={(page, pageSize) => {
            setChatPage(page);
            setChatLimit(pageSize);
          }}
          size="small"
          showSizeChanger={true}
          pageSizeOptions={["5", "10", "20", "50"]}
          showQuickJumper
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} chats`}
          style={{ margin: "10px 0", display: "flex", justifyContent: "center", gap: "4px" }}
        />

      </div>


    </div>
  );
};

export default ChatList;